module.exports = __webpack_public_path__ + "img/partners-icon19.8e358902.jpg";